export enum DocumentType {
  cpf = 'cpf',
  cnpj = 'cnpj'
}
